import { getCountry } from './CountryProvider';

export const UKOnly = ({ children }: { children: React.ReactNode }) => {
    if (getCountry() !== 'UK') {
        return null;
    }

    return <>{children}</>;
};

export const DEOnly = ({ children }: { children: React.ReactNode }) => {
    if (getCountry() !== 'DE') {
        return null;
    }

    return <>{children}</>;
};
